import { TPartnerHubClick, NAVIGATION_TRACKING_EVENTS, TNotificationIconClick } from './index';
import { trackByEvent } from '../../tracking/services';
import { COMPONENT_TYPE, TRACKING_DEFAULTS } from '../../tracking/constant';
import i18n, { defaultLang } from '@src/i18n';

const trackPartnerhubClickEvent = (
  pageGroup: string,
  country?: string,
  language?: string
) => {
  try {
    trackByEvent<TPartnerHubClick>(
      NAVIGATION_TRACKING_EVENTS.PARTNERHUB_CLICK.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategoryNavigation,
        component_name:
          NAVIGATION_TRACKING_EVENTS.PARTNERHUB_CLICK.component_name,
        event_type: NAVIGATION_TRACKING_EVENTS.PARTNERHUB_CLICK.event_type,
        country: country || '',
        language: language || '',
        pageGroup: pageGroup  || '',
      }
    );
  } catch (error) {
    console.log('tracking partnerHub click Error', error);
  }
};

const trackNotificationIconClickOpenEvent = (
  pageGroup: string,
  country?: string,
  language?: string
) => {
  try {
    trackByEvent<TNotificationIconClick> (
      NAVIGATION_TRACKING_EVENTS.NOTIFICATION_ICON_CLICK.event,
      {
        // eventCategory: '',
        component_name: NAVIGATION_TRACKING_EVENTS.NOTIFICATION_ICON_CLICK.component_name,
        // event_type: '',
        // country: country || '',
        language: i18n.language || defaultLang,
        // pageGroup: pageGroup  || '',
        component_type: NAVIGATION_TRACKING_EVENTS.NOTIFICATION_ICON_CLICK.component_type as COMPONENT_TYPE,
        list_action: 'open'
      }
    )
  } catch(error) {
    console.log('tracking notification icon click Error', error);
  }
}

const trackNotificationIconClickCloseEvent = (
  pageGroup: string,
  country?: string,
  language?: string
) => {
  try {
    trackByEvent<TNotificationIconClick> (
      NAVIGATION_TRACKING_EVENTS.NOTIFICATION_ICON_CLICK_CLOSE.event,
      {
        // eventCategory: '',
        component_name: NAVIGATION_TRACKING_EVENTS.NOTIFICATION_ICON_CLICK_CLOSE.component_name,
        component_type: NAVIGATION_TRACKING_EVENTS.NOTIFICATION_ICON_CLICK_CLOSE.component_type as COMPONENT_TYPE,
        // event_type: '',
        // country: country || '',
        language: i18n.language || defaultLang,
        // pageGroup: pageGroup  || '',
        list_action: 'close'
      }
    )
  } catch(error) {
    console.log('tracking notification icon click Error', error);
  }
}

export { trackPartnerhubClickEvent, trackNotificationIconClickOpenEvent,trackNotificationIconClickCloseEvent };
